import React from 'react';
import { API_KEY } from '../../stripleConfig';
import StripleCustomForm from '../../components/StripleCustomForm';
import StripleSavedForm from '../../components/StripleSavedForm';
import StripeCheckoutForm from '../../components/StripeCheckoutForm'
import StripleProductCard from '../../components/StripleProductCard';
import PageHeadline from '../../components/PageHeadline';
import {loadStripe} from '@stripe/stripe-js';
import {
  Elements,
  PaymentElement,
  ExpressCheckoutElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import './style.scss';

const stripePromise = loadStripe('pk_live_rBHqq8Hhajl1i3CsWRoBxD24');

class StripleCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      savedForm: true
    }
     /* } else {
      if (savedForm) {
        return (
        <Elements>
          <StripleSavedForm
            type={type}
            stripeCards={stripeCards}
            setNewCard={this.setNewCard}
            payProduct={payProduct}
            price={price}
            saveTokenToProduct={saveTokenToProduct}
          />
          </Elements>
        )
      } else {
        return (
          <Elements>
            <StripleCustomForm
              type={type}
              price={price}
              id={id}
              saveToken={saveToken}
              saveTokenToProduct={saveTokenToProduct}
            />
          </Elements>
        )
      }
    }*/
  }

  setNewCard = () => {
    this.setState({savedForm: false});
  };

  //set in options with {and backticks }

  getForm = (price, type, id) => {
    const {stripeCards, saveToken, saveTokenToProduct, payProduct, clientSecret, clientSecretCust} = this.props;
    const {savedForm} = this.state;

    const elementoptions = {
      clientSecret: `${clientSecret}`,
      customerSessionClientSecret: `${clientSecretCust}`
    }
    

    console.log("STRIPE CARDS STRIPE CHECKOUT CLIENTSECRET: ", clientSecret);
    console.log("STRIPE CARDS STRIPE CHECKOUT CUSTOMERSESSION: ", clientSecretCust);
    
   // if (!stripeCards) {
      return (
        <Elements stripe={stripePromise} options={elementoptions}>
          <StripeCheckoutForm
            price={price}
            type={type}
            id={id}
            saveToken={saveToken}
            saveTokenToProduct={saveTokenToProduct}
          />
        </Elements>
      )
  
  };

  render() {
    const {product, productOffer} = this.props;

    let price = productOffer.type === "auction" ? productOffer.bid : product.price;
    price = parseInt(price) + parseInt(price*0.05);

    console.log('dd', API_KEY);

    return (
   
        <div className="striple-page">
          <PageHeadline />
          <div className="page-container">
            <StripleProductCard
              product={product}
              productOffer={productOffer}
            />
            {
              this.getForm(price, product.type, productOffer.id)
            }
          </div>
        </div>
 
    )
  }
}

export default StripleCheckout;